import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const SportsmanRankContext = createContext<{
  params?: Routing.SportsmanRankParams
}>({})

export { SportsmanRankContext }
